// What a pinned SDK's React `./app` entry gives the app shell: its companion's pages (the companion
// window and the "Open the full page" route) and an overlay the shell mounts on every page (the chat
// window, the tour host). The shell imports no SDK: the project's web/main.tsx passes the entries of the
// SDKs it pins.
import * as React from 'react';

/** The window events the shell and the SDKs' overlays share (the same names as cortex's). */
export const OPEN_CHAT_EVENT = 'cortex:open-chat';
export const START_TUTORIAL_EVENT = 'cortex:start-tutorial';

export interface CompanionOverlayProps {
  slug: string;
  branch: string;
  /** The app open on the page (its key), or null. */
  app: string | null;
  /** The companion speed dial, for an overlay that takes the launcher's place (the chat). */
  dial: (p: { slug: string; branch: string; app: string; hidden: boolean }) => React.ReactNode;
}

export interface AppCompanion {
  /** The SDK module (`workflows`): only the companions of the app's pinned SDKs are offered. */
  module: string;
  /** Its pages by path under /p/:slug/b/:branch (`workflows`, `models/:modelName/run`). */
  pages?: Record<string, () => Promise<React.ComponentType>>;
  /** Mounted once on every project page (the chat window, the tour host). */
  Overlay?: React.ComponentType<CompanionOverlayProps>;
  /** The overlay renders the speed dial itself (the chat: the launcher becomes the dial). */
  ownsDial?: boolean;
}

const PagesCtx = React.createContext<Record<string, () => Promise<React.ComponentType>>>({});

export function CompanionPagesProvider({
  pages,
  children,
}: {
  pages: Record<string, () => Promise<React.ComponentType>>;
  children: React.ReactNode;
}) {
  return <PagesCtx.Provider value={pages}>{children}</PagesCtx.Provider>;
}

/** Every page of the pinned companions, by path. */
export const useCompanionPages = () => React.useContext(PagesCtx);
